module.exports = function requestAnimationFrame(fn) {
  var method = window.requestAnimationFrame || window.webkitRequestAnimationFrame || function (fn) {
    return setTimeout(fn, 16);
  };

  return method(fn);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/dom/request-animation-frame.js
// module id = 73
// module chunks = 0 1 2